export default [
  {
    path: "/download",
    name: "Download",
    meta: { hideTab: true },
    component: () => import("@/views/downloadApp/index.vue")
  }
];
